import { ApiBaseService } from 'api/apibase.service';
import { ArrangementPreview } from 'api/arrangements/types';
import { SearchSuggestionProduct } from 'components/Header/types';

class SearchArrangementApiService extends ApiBaseService {
  getSearch(keyword: string): Promise<ArrangementPreview[]> {
    return this.apibase
      .post<ArrangementPreview[]>('/search', {
        keyword,
      })
      .then(({ data }) => data);
  }

  getSearchSuggestions(keyword: string): Promise<SearchSuggestionProduct[]> {
    return this.apibase
      .post<SearchSuggestionProduct[]>('/search/suggestions', {
        keyword: keyword.length >= 99 ? keyword.slice(0, 99) : keyword,
      })
      .then(({ data }) => data);
  }
}
const searchArrangementApiService = new SearchArrangementApiService();

export { searchArrangementApiService };
